import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient, SettingsService } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { finalize } from 'rxjs';
import { ACLService } from '@delon/acl';

import { License } from '../../services/license.service';

@Component({
  selector: 'app-license-info',
  standalone: false,
  templateUrl: './license-info.component.html',
  styles: [
    `
      .module-viewport {
        height: 200px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicenseInfoComponent implements OnInit {
  visible = false;
  licenseInfo: License = new License();
  loading = false;

  @Input() tenantId: string = '';
  @Input() ownerId: string = '';

  constructor(
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private modalSrv: NzModalService,
    private settings: SettingsService,
    private acl: ACLService
  ) {}

  get isOwner(): boolean {
    const currentUserId = this.settings?.user && this.settings.user['userId'];
    return !!currentUserId && !!this.ownerId && currentUserId === this.ownerId;
  }

  get canManagePlan(): boolean {
    return this.isOwner || this.acl.can({ ability: ['subscription.view'], mode: 'allOf' });
  }

  ngOnInit(): void {
    if (!this.tenantId) return;
    this.loadLicense(this.tenantId, { forceUpdate: true });
  }

  showManagePlan() {
    if (!this.tenantId) return;
    if (!this.canManagePlan) return;

    this.visible = false;

    // Close all modals before navigation
    this.modalSrv.closeAll();

    this.router.navigate(['./account/subscription'], {
      queryParams: { tid: this.tenantId }
    });
  }

  private loadLicense(
    tenantId: string,
    options: { forceUpdate?: boolean } = {}
  ): void {
    if (!tenantId) return;
    const { forceUpdate = false } = options;
    this.loading = true;
    this.cdr.detectChanges();
    const params: any = { tid: tenantId };
    if (forceUpdate) params.forceUpdate = true;
    this.http
      .get(`api/license/info`, params)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        this.licenseInfo.fromJson(res);
      });
  }
}
